const AUTOMATED_AGENT_PATTERN = /bot|crawl|spider|slurp|teoma/i;

export function isBrowserEnvironment() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}

// Crawlers and automated browsers never get the cookie interface, so the banner text is not
// indexed and test runners are not blocked by it.
export function isAutomatedBrowser() {
    return isBrowserEnvironment()
        && (AUTOMATED_AGENT_PATTERN.test(navigator.userAgent || '') || Boolean(navigator.webdriver));
}
